webpackJsonp([915738553496],{

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(33);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Footer = __webpack_require__(49);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _legal = __webpack_require__(287);
	
	var _legal2 = _interopRequireDefault(_legal);
	
	var _reactHtmlParser = __webpack_require__(62);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _gatsbyLink = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Legal = function (_React$Component) {
	    _inherits(Legal, _React$Component);
	
	    function Legal() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Legal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            lang: _this.props.location.state ? _this.props.location.state.lang : 'es',
	            traducciones: _legal2.default
	        }, _this.pickLang = function (event) {
	            var lang = event.target.id;
	
	            switch (lang) {
	                case 'ca':
	                    _this.setState(function () {
	                        return { lang: 'ca' };
	                    });
	                    break;
	                case 'es':
	                    _this.setState(function () {
	                        return { lang: 'es' };
	                    });
	                    break;
	                case 'en':
	                    _this.setState(function () {
	                        return { lang: 'en' };
	                    });
	                    break;
	                default:
	                    _this.setState(function () {
	                        return { lang: 'en' };
	                    });
	                    break;
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Legal.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'infoPages' },
	                _react2.default.createElement(
	                    'h4',
	                    { onClick: function onClick() {
	                            return (0, _gatsbyLink.navigateTo)({
	                                pathname: '/',
	                                state: {
	                                    lang: _this2.state.lang
	                                }
	                            });
	                        } },
	                    ' ',
	                    this.state.traducciones.volver[this.state.lang]
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    this.state.traducciones.titulo[this.state.lang]
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    (0, _reactHtmlParser2.default)(this.state.traducciones.texto[this.state.lang])
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    { onClick: function onClick() {
	                            return (0, _gatsbyLink.navigateTo)({
	                                pathname: '/',
	                                state: {
	                                    lang: _this2.state.lang
	                                }
	                            });
	                        } },
	                    ' ',
	                    this.state.traducciones.volver[this.state.lang]
	                )
	            ),
	            _react2.default.createElement('div', { className: 'fill' }),
	            _react2.default.createElement(_Footer2.default, {
	                pickLang: this.pickLang,
	                copyright: this.state.traducciones.copyright,
	                lang: this.state.lang,
	                scroll: this.scroll,
	                location: this.props.history.location.pathname,
	                privacy: _index2.default.privacy,
	                terminosShort: _index2.default.terminosShort,
	                alternativeDisputeResolution: _index2.default.alternativeDisputeResolution
	            })
	        );
	    };
	
	    return Legal;
	}(_react2.default.Component);
	
	exports.default = Legal;
	;
	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  titulo: {
	    es: "Politica de privacidad",
	    ca: "Politica de privacitad",
	    en: "Privacy policy"
	  },
	  copyright: {
	    es: "© 2023 Nitsa Club. Todos los derechos reservados",
	    ca: "© 2023 Nitsa Club. Tots els drets reservats.",
	    en: "© 2023 Nitsa Club. All rights reserved"
	  },
	  volver: {
	    es: "volver a Nitsa",
	    ca: "tornar a Nitsa",
	    en: "back to Nitsa"
	  },
	  texto: {
	    es: "<br><br><p>De conformidad con la Regulaci\xF3n General de Protecci\xF3n de Datos de la Uni\xF3n Europea que entra en vigor el 25 de mayo, te informamos de que los datos personales que has facilitado han pasado a formar parte de un fichero responsabilidad de MURMURTOWN PRODUCCIONES S.L. y que tiene por finalidad la segmentaci\xF3n de perfil y env\xEDo de newsletter informativa que puede contener aspectos publicitarios propios y de terceros. El delegado de Protecci\xF3n de datos es UNIVER IURIS S.L. (http://www.uneon.es/). Tus datos ser\xE1n conservados mientras est\xE9s dado de alta en el e-mailing.<br></p><br>\n        <p>Puedes ejercer los derechos de acceso, limitaci\xF3n, portabilidad o reclamaci\xF3n a la Agencia Espa\xF1ola de Protecci\xF3n de Datos; y de supresi\xF3n o olvido, rectificaci\xF3n, cancelaci\xF3n y oposici\xF3n al tratamiento de datos o recepci\xF3n de e-mailing en el e-mail o en el domicilio sito en c/ \xC0laba, 140, 2\xBA 4\xAA, 08018 de Barcelona. Daremos respuesta a cualquier petici\xF3n. Contacta con nosotros si lo necesitas en lopd@nitsa.com.</p><br>",
	    ca: "<br><br><p>De conformitat amb la Regulaci\xF3 General de Protecci\xF3 de Dades de la Uni\xF3 Europea que entra en vigor el 25 de maig, us informem que les dades personals que has facilitat han passat a formar part d'un fitxer responsabilitat de MURMURTOWN PRODUCCIONES S.L. i que t\xE9 com a finalitat la segmentaci\xF3 de perfil i enviament de newsletter informativa que pot contenir aspectes publicitaris propis i de tercers. El delegat de Protecci\xF3 de dades \xE9s UNIVER IURIS S.L. (http://www.uneon.es/). Les teves dades seran conservades mentre estiguis donat d'alta a l'e-mailing.\n        <br></p><br>\n        <p>Pots exercir els drets d'acc\xE9s, limitaci\xF3, portabilitat o reclamaci\xF3 a l'Ag\xE8ncia Espanyola de Protecci\xF3 de Dades; i de supressi\xF3 o oblit, rectificaci\xF3, cancel\xB7laci\xF3 i oposici\xF3 al tractament de dades o recepci\xF3 d'e-mailing a l'e-mail o al domicili situat a c/ \xC0laba, 140, 2n 4a, 08018 de Barcelona. Donarem resposta a qualsevol petici\xF3. Contacta amb nosaltres si ho necessites a lopd@nitsa.com.</p><br>",
	    en: "<br><br><p>In accordance with the European Union General Data Protection Regulation which will apply from 25th May, we inform you that the personal data that you have facilitated has been stored in a file that is the responsibility of MURMURTOWN PRODUCCIONES S.L. and whose purpose is to develop a segmented profile and to send an informative newsletter that may contain advertising aspects of its own and those of third parties. The Data Protection delegate is UNIVER IURIS S.L. (http://www.uneon.es/). Your data will be stored only for as long as you are subscribed to the e-mailing.\n        <br></p><br>\n        You can exercise the right to access, limitation, portability or complaint to the Spanish Data Protection Authority, and of rectification, cancellation and opposition of your data or to receiving the e-mailing the via the e-mail address below or at the headquarters at C/ \xC0laba, 140, 2\xBA 4\xAA, 08018 in Barcelona. We will reply to any enquiries. Do not hesitate to get in touch should you need to at lopd@nitsa.com.</p><br>"
	  }
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-c717d1c9c542cdf9dd3f.js